import styled from 'styled-components';
import colors from 'pubweb-react-components/dist/styles/colors';
import variables from '../variables';

const FooterStyles = styled.div`
    .footer{
        height: 75px;
        background: rgba(245, 245, 245, 0.48);
        padding: 0 30px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
    }
`;

export default FooterStyles;